import React from 'react';
import PropTypes from 'prop-types';
import withLocalization from '../../higherOrderComponents/withLocalization';
import Icon from '../Icon';
import { acceptedStatuses } from './_allowedPropTypes';

const HugeStatusIndicator = ({ status: passedStatus, labels = {}, translate }) => {
  const statusData = acceptedStatuses.find(({ statusName }) => statusName === passedStatus) || {};

  const {
    statusName,
    iconName,
    iconColor,
    iconClasses = []
  } = statusData;

  iconClasses.push(`icon-color-${iconColor}`);

  return (
    <article className='huge-status-indicator'>
      <Icon iconName={iconName} className={iconClasses.join(' ')} />
      <strong>{labels[statusName] || translate(`text-${statusName}`)}</strong>
    </article>
  );
};

HugeStatusIndicator.propTypes = {
  status: PropTypes.oneOf(acceptedStatuses.map(({ statusName }) => statusName)).isRequired,
  labels: PropTypes.shape({
    pending: PropTypes.string,
    success: PropTypes.string,
    error: PropTypes.string
  })
};

export default withLocalization(HugeStatusIndicator, 'elements/hugeStatusIndicator');